import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { DateTime } from "luxon";
import { useTranslate, useLanguage } from "lang/Translate";
import axios from "axios";

//components
import Errors from "components/auth/Errors";
import Tooltip from "components/common/tooltip/Tooltip";
import LanguageToggle from "components/common/LanguageToggle/LanguageToggle";

// hooks
import { useLogOut } from "components/auth/LogOut";

//css
import "./AirlineCreation.scoped.scss";

//php
import api from "api/api";

//json
import airportList from "assets/json/airportList.json";
import SlidingTextButton from "components/common/SlidingTextButton/SlidingTextButton";

const AirlineCreation = () => {
	const [type, setType] = useState("");
	const [name, setName] = useState("");
	const [nameWasSet, setNameWasSet] = useState(false);
	const [hubCountry, setHubCountry] = useState("");
	const [hubIdent, setHubIdent] = useState("");
	const [errors, setErrors] = useState([]);

	const currLanguage = useLanguage();
	const history = useHistory();
	const { signOut: logOut } = useLogOut();

	const createAirline = async e => {
		e.preventDefault();

		const airlineData = {
			info: {
				name,
				type,
				stats: {
					longestRoute: 0,
					shortestRoute: 0,
					totalRouteLength: 0,
					routeCount: 0,
					passengersTraveled: {
						total: 0,
						economy: 0,
						premium: 0,
						business: 0,
						first: 0
					},
					fleetCount: 0,
					baseCount: 0,
					founded: DateTime.utc().toSeconds()
				},
				logo: {},
				livery: []
			},
			hub: hubIdent,
			settings: {
				onlineCheckIn: false,
				dutyFree: false,
				cleaning: 0,
				alcohol: false,
				economy: {
					freeWiFi: false
				},
				premium: {
					priorityCheckIn: false,
					priorityBoarding: false,
					freeWiFi: false
				},
				business: {
					priorityCheckIn: false,
					priorityBoarding: false,
					freeWiFi: false
				},
				first: {
					priorityCheckIn: false,
					priorityBoarding: false,
					freeWiFi: false
				}
			},
			staffSalary: {
				pilot: [90, 180, 260, 550],
				flight_attendant: [150, 280],
				date: DateTime.utc()
			}
		};

		try {
			await axios.post(`${api}/airline`, airlineData);

			setErrors([]);
			history.push("/game");
		} catch (e) {
			if (e.response.status === 409) {
				setErrors([{ error: "Wybrana nazwa jest już zajęta", errorEn: "The selected name is already taken" }]);
				return;
			}

			if (e.response.status === 422) {
				setErrors([e.response.data]);
				return;
			}

			console.error(e);
		}
	};

	const changeCountry = code => {
		setHubCountry(code);
		setHubIdent("");
	};

	return (
		<div className="airline_creation">
			<LanguageToggle />
			<div className="container">
				<div>
					<h1>{useTranslate({ component: "AirlineCreation", Tkey: "HEADING" })}</h1>

					<form onSubmit={e => createAirline(e)}>
						<div>
							<div>
								<label htmlFor="airlineType">
									{useTranslate({ component: "AirlineCreation", Tkey: "AIRLINE_TYPE" })}
								</label>
								<div className="flex flex--columns flex--centerv">
									<select
										type="text"
										id="airlineType"
										value={type}
										onChange={e => setType(e.target.value)}
									>
										<option value="" disabled>
											---
										</option>
										<option value="pax">
											{useTranslate({ component: "AirlineCreation", Tkey: "REGULAR_AIRLINE" })}
										</option>
										<option value="cargo">
											{useTranslate({ component: "AirlineCreation", Tkey: "CARGO_AIRLINE" })}
										</option>
										<option value="regional">
											{useTranslate({ component: "AirlineCreation", Tkey: "REGIONAL_AIRLINE" })}
										</option>
										<option value="charter">
											{useTranslate({ component: "AirlineCreation", Tkey: "CHARTER_AIRLINE" })}
										</option>
										<option value="cheap">
											{useTranslate({ component: "AirlineCreation", Tkey: "CHEAP_AIRLINE" })}
										</option>
									</select>
									<Tooltip text={useTranslate({ component: "AirlineCreation", Tkey: "TOOLTIP_4" })} />
								</div>
							</div>

							<div className={type !== "pax" ? "hide" : ""}>
								<label htmlFor="airlineName">
									{useTranslate({ component: "AirlineCreation", Tkey: "AIRLINE_NAME" })}
								</label>
								<div className="flex flex--columns flex--centerv">
									<input
										type="text"
										id="airlineName"
										autoComplete="off"
										value={name}
										onChange={e => {
											setName(e.target.value);
											setNameWasSet(true);
										}}
									/>
									<Tooltip text={useTranslate({ component: "AirlineCreation", Tkey: "TOOLTIP_1" })} />
								</div>
							</div>

							<div className={type !== "pax" || !nameWasSet ? "hide" : ""}>
								<label htmlFor="country">
									{useTranslate({ component: "AirlineCreation", Tkey: "COUNTRY" })}
								</label>
								<div className="flex flex--columns flex--centerv">
									<select id="country" value={hubCountry} onChange={e => changeCountry(e.target.value)}>
										<option value="" disabled>
											---
										</option>
										{Object.values(airportList)
											.sort((a, b) =>
												currLanguage === "PL"
													? a._info.namePL < b._info.namePL
														? -1
														: 1
													: a._info.name < b._info.name
													? -1
													: 1
											)
											.map(value => {
												return (
													<option value={value._info.code} key={value._info.code}>
														{currLanguage === "PL" ? value._info.namePL : value._info.name}
													</option>
												);
											})}
									</select>
									<Tooltip text={useTranslate({ component: "AirlineCreation", Tkey: "TOOLTIP_2" })} />
								</div>
							</div>

							<div className={type !== "pax" || !nameWasSet || hubCountry === "" ? "hide" : ""}>
								<label htmlFor="airport">
									{useTranslate({ component: "AirlineCreation", Tkey: "AIRPORT" })}
								</label>
								<div className="flex flex--columns flex--centerv">
									<select id="airport" value={hubIdent} onChange={e => setHubIdent(e.target.value)}>
										<option value="" disabled>
											---
										</option>
										{Object.values(airportList[hubCountry] || {})
											.filter(item => (item.longitude_deg ? true : false)) // dismiss the _info object
											.sort((a, b) => a.name.localeCompare(b.name))
											.map(airport => {
												return (
													<option value={airport.ident} key={airport.ident}>
														{airport.name}
													</option>
												);
											})}
									</select>
									<Tooltip text={useTranslate({ component: "AirlineCreation", Tkey: "TOOLTIP_3" })} />
								</div>
							</div>

							<div className={[type === "pax" || type === "" ? "hide" : "", "no_support"].join(" ")}>
								Niestety, obecnie dostępna jest jedynie linia regularna. Pozostałe typy linii zostaną
								zaimplementowane w przyszłych wersjach gry
							</div>

							<Errors errors={errors} />
						</div>

						<input
							type="submit"
							className={type !== "pax" || type === "" || hubCountry === "" || hubIdent === "" ? "hide" : ""}
							value={useTranslate({ component: "AirlineCreation", Tkey: "CREATE_GROUP" })}
						/>
					</form>

					<div>
						<SlidingTextButton
							text={useTranslate({ component: "AirlineCreation", Tkey: "LOG_OUT" })}
							icon={<i className="fas fa-sign-out-alt icon" />}
							background="darkBlue"
							onClick={logOut}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AirlineCreation;
